<div class="col">
  <div class="container">
    <div class="row g-4">
      <div
        *ngFor="let options of conclusionOptions; let i = index"
        class="col-md-6"
      >
        <select
          id="part{{ i }}"
          class="form-select cursor-pointer"
          aria-label="Pre defined conclusion inputs"
          [disabled]="
            patientHeaderInformations?.patientStatus >
            caseStatus.WaitingConsultation
          "
          (change)="updateConclusionOutput($event, i.toString())"
        >
          <option [hidden]="true" selected>
            {{ options?.title }}
          </option>
          <option
            *ngFor="let optionItem of options.conclusionOptionContents"
            [value]="optionItem.id"
          >
            {{ optionItem.title }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="text-inverse-light bg-light p-6 fs-4 my-3">
    <b>
      {{ "patient" | translate }}:
      {{ patientHeaderInformations?.name || "-" }}
      {{ patientHeaderInformations?.lastName || "-" }}
    </b>
    <br />
    <br />
    <textarea
      rows="10"
      class="form-control"
      [(ngModel)]="selectedConclusionText"
      [readonly]="
        patientHeaderInformations?.patientStatus >
        caseStatus.WaitingConsultation
      "
    ></textarea>
    <br />
    {{ "bestRegards" | translate }}, <br />
    {{ currentUser?.name }}
  </div>
</div>

<div class="d-grid gap-2 mt-4">
  <div class="col text-end">
    <button
      type="button"
      class="btn btn-primary cursor-pointer"
      data-bs-toggle="modal"
      [attr.data-bs-target]="'#previewFinalReportModal'"
      (click)="previewReport()"
      [disabled]="
        !selectedConclusionText.trim() ||
        patientHeaderInformations?.patientStatus >
          caseStatus.WaitingConsultation
      "
    >
      {{ "previewFinalReport" | translate }}
    </button>
    <button
      type="button"
      (click)="sendReport()"
      class="btn btn-dark ms-3 cursor-pointer"
      [disabled]="
        !selectedConclusionText.trim() ||
        patientHeaderInformations?.patientStatus >
          caseStatus.WaitingConsultation
      "
    >
      {{ "sendReport" | translate }}
    </button>
  </div>
</div>

<app-preview-final-report-modal
  [previewReportErrorText]="previewReportErrorText"
/>
